import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "dot"]

  connect() {
    this.currentIndex = 0
    this.slideCount = this.element.querySelectorAll('.hero-carousel-slide').length || 1
    this.startAutoplay()
  }

  disconnect() {
    this.stopAutoplay()
  }

  next() {
    this.goToSlide((this.currentIndex + 1) % this.slideCount)
  }

  prev() {
    this.goToSlide((this.currentIndex - 1 + this.slideCount) % this.slideCount)
  }

  goTo(event) {
    const index = parseInt(event.currentTarget.dataset.index)
    this.goToSlide(index)
  }

  goToSlide(index) {
    this.currentIndex = index
    this.trackTarget.style.transform = `translateX(-${index * 100}%)`

    this.dotTargets.forEach((dot, i) => {
      if (i === index) {
        dot.style.width = "24px"
        dot.style.background = "#4F46E5"
      } else {
        dot.style.width = "8px"
        dot.style.background = "#D1D5DB"
      }
    })

    this.resetAutoplay()
  }

  startAutoplay() {
    this.autoplayTimer = setInterval(() => this.next(), 5000)
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer)
    }
  }

  resetAutoplay() {
    this.stopAutoplay()
    this.startAutoplay()
  }
}
